const userRouter = [
    {
        path: "list-users",
        name: "user",
        component: () => import("@/views/admin/user"),
        default: true,
        meta: {
            model: "users",
            // requiresAuth: true,
        },
    },
    {
        path: "list-users/add",
        name: "addUser",
        component: () => import("@/views/admin/user/function"),
        default: true,
        meta: {
            model: "users",
            // requiresAuth: true,
        },
    },
    {
        path: "list-users/edit/:id",
        name: "editUser",
        component: () => import("@/views/admin/user/function"),
        default: true,
        meta: {
            model: "users",
            // requiresAuth: true,
        },
    },
];
export default userRouter;